/** Normalize refuel event fields from busRefuelEvents / lorryRefuelEvents. */
export function refuelEventTimestampMs(e: Record<string, unknown>): number {
  const v = e.timestamp ?? e.recordedAt ?? e.createdAt;
  if (v && typeof v === 'object' && 'toDate' in (v as object)) {
    return ((v as { toDate: () => Date }).toDate?.() ?? new Date()).getTime();
  }
  if (typeof v === 'number') return v;
  return 0;
}

export function refuelEventLiters(e: Record<string, unknown>): number {
  const n = Number(e.litersAdded ?? e.litres ?? e.liters ?? 0);
  return Number.isFinite(n) ? n : 0;
}

export function refuelEventCostKsh(e: Record<string, unknown>): number {
  const n = Number(e.costEstimate ?? e.costKsh ?? e.cost ?? 0);
  return Number.isFinite(n) ? n : 0;
}

export function refuelEventVehicleId(e: Record<string, unknown>): string {
  return String(e.busId ?? e.lorryId ?? '');
}
